export const APP_STORE_URL = 'https://apps.apple.com/us/app/convolines-real-life-english/id6785139538';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.convolines.app';
export const CONTACT_URL = 'https://tally.so/r/7RAVb2';
export const SUPPORT_EMAIL = 'info@highvocab.com';
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.convolines.co';
